import React, { FC } from "react";
import { FileTextOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { IChatMessageCardProps } from "../Types/Type";
import { DownloadingFiles } from "../../../utils/utilities/Downloads";
import { formatDateNumber } from "../../../utils/utilities/FormattedDate";
import { MessageWithLink } from "../../../utils/utilities/MessageWithLink";

import classes from "./ChatMessageCard.module.css";
import { useGetPermissionQuery } from "../../../store/api/permission.api";
import { USER } from "../../../types/indexTypeEnum";

// карточка сообщения в чате
export const ChatMessageCard: FC<IChatMessageCardProps> = (props) => {
  const { id, is_my, text, file, created_at } = props;

  const { data: perissionData } = useGetPermissionQuery(undefined);

  const userRole = perissionData?.data.user.type;

  const date = new Date(`${created_at}`);
  const hours = formatDateNumber(date.getHours());
  const minutes = formatDateNumber(date.getMinutes());
  const month = formatDateNumber(date.getMonth() + 1);
  const day = formatDateNumber(date.getDate());
  const rootClasses = `${classes.chatMessageCard} ${
    is_my ? classes.chatMessageCard_isMy : ``
  }`;

  const author = () => {
    if (is_my) {
      return "Вы";
    } else {
      return userRole !== USER.SUPPORT_CREDIT
        ? "Кредитный специалист"
        : "Клиент/агент";
    }
  };

  return (
    <div key={id} className={rootClasses}>
      <div className={classes.chatMessageCard__header}>
        <div className={classes.chatMessageCard__author}>{author()}</div>
        <div className={classes.chatMessageCard__date}>{`${day}.${month}`}</div>
      </div>
      <div className={classes.chatMessageCard__content}>
        {file && (
          <div className={classes.chatMessageCard__fileList}>
            <Button
              className={classes.chatMessageCard__fileLink}
              type="link"
              onClick={() =>
                DownloadingFiles({
                  url: `auth/chat/${file.message_id}/file`,
                  fileName: `${file.name}`,
                })
              }
            >
              <FileTextOutlined className={classes.chatMessageCard__fileIcon} />
              {file.name}
            </Button>
          </div>
        )}
        <div className={classes.chatMessageCard__text}>
          <MessageWithLink text={text} />
        </div>
        <div className={classes.chatMessageCard__time}>
          {`${hours}:${minutes}`}
        </div>
      </div>
    </div>
  );
};
